import React from 'react';
// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import CommonPopUpCentered from '../../../components/popup/common-popup-centered';
// import * as gtUtil from "../../../core/utility";
// import { InstagramDMAutomation } from '../../../core/services/dm-automation-instagram.service';
import { PostMediaProps } from 'custom-type';

// const instagramDMAutomationService: InstagramDMAutomation = new InstagramDMAutomation();

type ErrorMessageProps = {
  status: boolean;
  message: string;
}

type Props = {
  influencerAccounts: any;
  UserReducer: any;
  selectedPosts: PostMediaProps[];
  handlePostClick: (media: PostMediaProps) => void;
  selectedPostsError: ErrorMessageProps;
}

const ShowPostReel = (props: Props) => {
  // const [selectedPosts, setSelectedPosts] = useState<number[]>([]); // State to track selected posts (multiple)
  // const [openAdditionalSettingsModal, setOpenAdditionalSettingsModal] = useState(false);
  // const [loading, setLoading] = useState(false);
  // const [igMediaData, setIgMediaData] = useState(props.selectedPosts);

  // const handleMorePosts = () => setOpenAdditionalSettingsModal(true);
  //   const handleCloseMorePosts = () => {
  //   setOpenAdditionalSettingsModal(false);
  // }

  // Get all accounts of the influencer
  // async function getInstagramPostMedias() {
  //   try {
  //     setLoading(true);
  //     const res = await instagramDMAutomationService.getInstagramPostMedias({
  //       ig_access_token: props.influencerAccounts[0]?.ig_access_token,
  //       connected_instagram_account_id: props.influencerAccounts[0]?.connected_instagram_account_id
  //     });

  //     if (res.status === gtUtil.Constants.SUCCESS) {
  //       setIgMediaData(res?.data?.media?.data || []);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching getInstagramPostMedias:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // }

  // useEffect(() => {
  //   if (props.influencerAccounts[0]?.ig_access_token && props.influencerAccounts[0]?.connected_instagram_account_id)
  //   getInstagramPostMedias()
  // }, [props.influencerAccounts]);

  return (
    <>
      <li>
        <span className='pb-3 d-inline-flex fs-14'>Select the Post or Reel you want to use in automation.</span>
        <div className='specific-post-container'>
          {/* <div className='d-flex fs-14 mb-3'>
            <span>Specific Post or Reel</span>
            <Link to="javascript:void(0)" className='ms-auto' onClick={handleMorePosts}>See more</Link>
          </div> */}
          <div className='post-image-container'>
            {/* {[...Array(9)].map((_, index) => ( */}
            {/* {igMediaData.slice(0, 9).map((media_data: PostMediaProps, index) => ( */}
            {props.selectedPosts.map((media_data: PostMediaProps, index) => (
              <div
                key={index}
                // className={`post-image ${props.selectedPosts.some(post => post.shortcode === media_data.shortcode) ? 'active' : ''}`}
                className='post-image active'
                // onClick={() => "javascript:void(0)"}//props.handlePostClick(media_data)} // Handle post selection
                style={{ cursor: 'pointer' }} // Make the image clickable
              >
                <a
                  href={media_data.permalink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={media_data?.gcp_media_file_url}
                    alt={`Post${media_data.shortcode}-${index + 1}`}
                    style={{
                      width: '98px',
                      height: '98px',
                      // border: props.selectedPosts.some(post => post.shortcode === media_data.shortcode) ? '1px solid #000' : 'none', // Optional styling for active state
                      border: '1px solid #000',
                    }}
                  />
                </a>
              </div>
            ))}
          </div>
        </div>
        {props.selectedPostsError.status && <small className='text-danger'>{props.selectedPostsError.message}</small>}
      </li>
      {/* <CommonPopUpCentered
        centered
        className={`popup-see-more modal-medium  mx-auto`}
        openModal={openAdditionalSettingsModal}
        modalTitle=""
        modalContent=""
        onClose={() => handleCloseMorePosts()}>
        <div className="popup-content">
          <ul>
            <li>
              <div className='post-image-container'>
              {igMediaData.map((media_data: PostMediaProps, index) => (
                <div
                  key={index}
                  className={`post-image ${props.selectedPosts.some(post => post.shortcode === media_data.shortcode) ? 'active' : ''}`} // Add 'active' class if selected
                  onClick={() => "javascript:void(0)"}//props.handlePostClick(media_data)} // Handle post selection
                  style={{ cursor: 'pointer' }} // Make the image clickable
                >
                  <img
                    src={media_data?.thumbnail_url ? media_data.thumbnail_url : media_data.media_url}
                    alt={`Post${media_data.shortcode}-${index + 1}`}
                    style={{
                      width: '98px',
                      height: '98px',
                      border: props.selectedPosts.some(post => post.shortcode === media_data.shortcode) ? '1px solid #000' : 'none', // Optional styling for active state
                    }}
                  />
                </div>
              ))} 
            </div>
            </li>
          </ul>
        </div>
      </CommonPopUpCentered> */}
    </>
  );
};

export default ShowPostReel;
